import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { supabase } from '@/services/supabase';

const BuddhistSchoolBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserSchool = async () => {
      try {
        // Lấy session hiện tại
        const { data: sessionData } = await supabase.auth.getSession();
        
        if (!sessionData.session) {
          setShowBanner(false);
          setIsLoading(false);
          return;
        }
        
        // Lấy thông tin từ bảng users
        const { data: userData, error } = await supabase
          .from('users')
          .select('buddhist_school')
          .eq('id', sessionData.session.user.id)
          .single();
        
        if (error) {
          console.error('Lỗi khi lấy thông tin user:', error);
          // Mặc định hiển thị banner nếu có lỗi
          setShowBanner(true);
        } else {
          console.log('Giá trị buddhist_school:', userData.buddhist_school);
          // Hiển thị banner nếu người dùng chưa chọn tông phái (buddhist_school là null)
          setShowBanner(userData.buddhist_school === null);
        }
      } catch (error) {
        console.error('Lỗi khi kiểm tra tông phái:', error);
        // Mặc định hiển thị banner nếu có lỗi
        setShowBanner(true);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkUserSchool();
  }, []);

  if (isLoading) return null;

  return (
    <div className="container mx-auto px-4">
      <Card className="bg-gradient-to-r from-purple-100 to-indigo-100 dark:from-purple-950/40 dark:to-indigo-950/40 border-0 shadow-md overflow-hidden my-6">
        <CardContent className="p-0">
          <div className="flex flex-col md:flex-row items-center">
            <div className="w-full md:w-1/4 flex justify-center p-4">
              <div className="relative w-[150px] h-[150px] flex items-center justify-center">
                <div className="absolute inset-0 bg-purple-500 opacity-10 rounded-full animate-pulse"></div>
                <img 
                  src="https://imagedelivery.net/meCI2KDHmnUhVs_SxNm-Og/fd677611-47d8-46bd-6624-6b88e5966000/public" 
                  alt="Meditation icon"
                  className="w-[120px] h-[120px] rounded-full object-cover"
                />
              </div>
            </div>
            
            <div className="w-full md:w-2/4 p-6">
              <h3 className="text-xl md:text-2xl font-bold mb-2">Khám phá tông phái Phật giáo phù hợp với bạn!</h3>
              <p className="text-muted-foreground mb-4">
                Làm bài quiz ngắn để tìm ra tông phái phù hợp nhất với tính cách và xu hướng tâm linh của bạn. 
                Điều này sẽ giúp chúng tôi cá nhân hóa trải nghiệm học tập của bạn.
              </p>
              <Button asChild size="lg" className="bg-purple-600 hover:bg-purple-700">
                <Link to="/buddhist-school/quiz">Bắt đầu khám phá</Link>
              </Button>
            </div>
            
            <div className="hidden md:block w-full md:w-1/4">
              <div className="relative h-full">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-purple-500/20 dark:to-purple-500/40" />
                <img 
                  src="https://imagedelivery.net/meCI2KDHmnUhVs_SxNm-Og/dbd85d1c-8dad-4ed1-490a-04f95b1b2600/public" 
                  alt="Tông phái Phật giáo"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BuddhistSchoolBanner; 